import React from "react";
import { useTranslation } from "react-i18next";
import { DELIMITER_CHOICES } from "../../../../features/data-upload/utils/delimiterChoices";
import "../../../../index.css";

interface DelimiterInputProps {
  delimiter: string;
  setDelimiter: (delimiter: string) => void;
}

const DelimiterInput: React.FC<DelimiterInputProps> = ({ delimiter, setDelimiter }) => {
  const { t } = useTranslation('dataUpload');
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setDelimiter(e.target.value);
  };

  const inputId = "delimiter-input";
  const hasError = !delimiter;

  return (
    <div className="delimiter-container">
      <label htmlFor={inputId} className="delimiter-label">
        {t('delimiterInput.label')}
      </label>
      <div className="input-container">
        <select
          id={inputId}
          value={delimiter}
          onChange={handleChange}
          className={`delimiter-input ${hasError ? 'error' : ''}`}
          required
          aria-invalid={hasError}
          aria-describedby={hasError ? "delimiter-error" : undefined}
        >
          <option value="" disabled>
            {t('delimiterInput.placeholder')}
          </option>
          {DELIMITER_CHOICES.map((choice) => (
            <option key={choice.value} value={choice.value}>
              {t(choice.i18nKey)}
            </option>
          ))}
        </select>
      </div>
      {hasError && (
        <p id="delimiter-error" className="delimiter-error-message">
          {t('delimiterInput.errorMessage')}
        </p>
      )}
    </div>
  );
};

export default DelimiterInput;
